(function(){
  const root = document.getElementById('mp-peptide-calculator');
  if(!root) return;

  const state = { syringeMl: 1.0, vialMg: 5, bacMl: 2, doseMcg: 250 };

  const $ = (id)=>document.getElementById(id);

  const el = {
    vialOtherRow: $('mp_vial_other_row'),
    bacOtherRow: $('mp_bac_other_row'),
    doseOtherRow: $('mp_dose_other_row'),
    vialOther: $('mp_vial_other'),
    bacOther: $('mp_bac_other'),
    doseOther: $('mp_dose_other'),
    sentence: $('mp_sentence'),
    conc: $('mp_conc'),
    drawMl: $('mp_draw_ml'),
    units: $('mp_units'),
    marker: $('mp_marker'),
    labels: $('mp_scale_labels')
  };

  function num(v){
    const n = parseFloat(String(v).replace(/[^0-9.]/g,''));
    return Number.isFinite(n) ? n : 0;
  }
  function fmt(n, d){
    if(!Number.isFinite(n)) return '—';
    return n.toFixed(d);
  }
  function setPressed(groupEl, pressedBtn){
    groupEl.querySelectorAll('.mp-pill').forEach(b=>{
      b.setAttribute('aria-pressed', b===pressedBtn ? 'true' : 'false');
    });
  }
  function getGroupValue(groupName){
    if(groupName === 'vialmg'){
      if(state.vialMg === 'other') return num(el.vialOther.value);
      return num(state.vialMg);
    }
    if(groupName === 'bacml'){
      if(state.bacMl === 'other') return num(el.bacOther.value);
      return num(state.bacMl);
    }
    if(groupName === 'dosemcg'){
      if(state.doseMcg === 'other') return num(el.doseOther.value);
      return num(state.doseMcg);
    }
    if(groupName === 'syringe'){
      return num(state.syringeMl);
    }
    return 0;
  }
  function updateOtherVisibility(){
    el.vialOtherRow.classList.toggle('mp-hidden', state.vialMg !== 'other');
    el.bacOtherRow.classList.toggle('mp-hidden', state.bacMl !== 'other');
    el.doseOtherRow.classList.toggle('mp-hidden', state.doseMcg !== 'other');
  }
  function setScaleLabels(syringeMl){
    const maxUnits = Math.round(syringeMl * 100);
    const ticks = [0, Math.round(maxUnits*0.25), Math.round(maxUnits*0.5), Math.round(maxUnits*0.75), maxUnits];
    el.labels.innerHTML = ticks.map(t=>`<span>${t}</span>`).join('');
  }
  function recalc(){
    const syringeMl = getGroupValue('syringe');
    const vialMg = getGroupValue('vialmg');
    const bacMl = getGroupValue('bacml');
    const doseMcg = getGroupValue('dosemcg');

    if(syringeMl <= 0 || vialMg <= 0 || bacMl <= 0 || doseMcg <= 0){
      el.sentence.innerHTML = 'Enter valid values.';
      el.conc.textContent = '—';
      el.drawMl.textContent = '—';
      el.units.textContent = '—';
      el.marker.style.left = '0%';
      return;
    }

    const concMcgPerMl = (vialMg * 1000) / bacMl;
    const drawMl = doseMcg / concMcgPerMl;
    const units = drawMl * 100;

    const maxUnits = syringeMl * 100;
    const clampedUnits = Math.max(0, Math.min(units, maxUnits));
    const pct = (clampedUnits / maxUnits) * 100;

    el.conc.textContent = `${fmt(concMcgPerMl,0)} mcg/mL`;
    el.drawMl.textContent = `${fmt(drawMl,3)} mL`;
    el.units.textContent = `${fmt(units,1)} units`;

    el.sentence.innerHTML =
      `To measure <b>${fmt(doseMcg,0)} mcg</b>, draw <b>${fmt(drawMl,3)} mL</b> ( <b>${fmt(units,1)} units</b> on a <b>${fmt(syringeMl,1)} mL</b> insulin syringe ).`;

    el.marker.style.left = `${pct}%`;
    setScaleLabels(syringeMl);
  }

  root.querySelectorAll('.mp-group').forEach(group=>{
    const groupName = group.getAttribute('data-group');
    group.querySelectorAll('.mp-pill').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const val = btn.getAttribute('data-value');

        if(groupName === 'syringe') state.syringeMl = val;
        if(groupName === 'vialmg') state.vialMg = (val === 'other') ? 'other' : val;
        if(groupName === 'bacml') state.bacMl = (val === 'other') ? 'other' : val;
        if(groupName === 'dosemcg') state.doseMcg = (val === 'other') ? 'other' : val;

        setPressed(group, btn);
        updateOtherVisibility();
        recalc();
      });
    });
  });

  [el.vialOther, el.bacOther, el.doseOther].forEach(inp=>{
    inp.addEventListener('input', recalc);
  });

  updateOtherVisibility();
  recalc();
})();